import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Models } from '@ibexfusion/models';
import { PackageService } from '@services/packages/package.service';
import { PackageInstalledAppsService } from '@services/packages/package-installed-apps.service';
import { PackageInstalledWidgetsService } from '@services/packages/package-installed-widgets.service';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { ApplicationGenerationComponent } from '../../components/application-generation/application-generation.component';
import { DynamicContentEntranceService } from '@services/dynamic-content/dynamic-content-entrance.service';
import { CompositionService } from '@services/compositions/composition.service';
import { ImportService } from '@services/imports/import.service';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { CompositionAppService } from '@services/compositions/composition-app.service';
import { AppPickerDialogComponent } from '../packages/package-installed-apps-manager/app-picker-dialog/app-picker-dialog.component';
import { CodeSnippetService } from '@services/code-snippets/code-snippet.service';
import { EditAppDialogComponent } from './dialogs/ibextouch-app-dialog/edit-app-dialog.component';
import { MessengerService } from '@services/messenger/messenger.service';
import { DialogService } from '@services/dialog/dialog.service';
import { AppTranslationMap } from '../../maps/app-translation.map';
import { MenuItemService } from '@services/menu-items/menu-item.service';
import { ContentEntryService } from '@services/content-entries/content-entry.service';
import { PageAction } from '../../components/page-actions/page-actions.component';
import { PrivilegeGuard } from '../../guards/privilege.guard';
import { QueService } from '@services/que/que.service';
import { TranslateService } from '@services/translate/translate.service';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { GameSessionService } from '@services/game-sessions/game-session.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  providers: [PackageInstalledAppsService, PackageInstalledWidgetsService, DynamicContentEntranceService, CompositionService, ImportService, CompositionAppService,
    CodeSnippetService, MenuItemService, ContentEntryService, QueService, GameSessionService],
  standalone: false
})
export class NavigationComponent implements OnInit {
  packageId: string;
  package: Models.Package;
  compositions: Models.Composition[];
  buttons: any[] = [];
  selectedIndex = 0;
  activeField: string;
  items: any[];
  entrancesById = {};
  entryByCompositionAppId = {};
  apps: Models.PackageInstalledApp[];
  widgets: Models.PackageInstalledWidget[];
  languages: string[];
  availableApps: any[];
  superadmin = false;
  app;
  public pageActions: PageAction[];

  constructor(
    private activatedRoute: ActivatedRoute, private packageService: PackageService, private compositionService: CompositionService, private appService: PackageInstalledAppsService,
    private widgetService: PackageInstalledWidgetsService, private entranceService: DynamicContentEntranceService, private ms: MessengerService,
    private importService: ImportService, private dialog: MatDialog, private compositionAppService: CompositionAppService, private snippetService: CodeSnippetService,
    private dialogService: DialogService, private menuItemService: MenuItemService, private entryService: ContentEntryService, private priv: PrivilegeGuard, private que: QueService,
    private ts: TranslateService, private snackbar: SnackbarService, private gameSession: GameSessionService
  ) {
    this.packageId = this.activatedRoute.snapshot.params['id'];
    this.app = this.activatedRoute.snapshot.queryParams['app'];
    this.ms.$superadminPrivileges.subscribe(privileges => {
      this.superadmin = !!(privileges || []).find(el => el.privilegeName === 'superadmin' && el.value === 'packages');
    });
    if (this.packageId) {
      window['forcePackage'] = this.packageId;
    }
    this.pageActions = [
      new PageAction({
        icon: 'language', title: '', translationString: 'general.queuePriority', hidden: !this.priv.checkIfPrivilege('write', 'packages'),
        callback: () => {
          this.que.triggerPriority(this.packageId);
        }
      })
    ];
  }

  async ngOnInit() {
    this.buttons = [];
    this.package = await this.packageService.get(this.packageId);
    this.package.installedTabletAppIds = this.package.installedTabletAppIds?.length ? this.package.installedTabletAppIds : JSON.parse(JSON.stringify(this.package.installedAppIds));
    this.package.installedTabletWidgetIds = this.package.installedTabletWidgetIds?.length ? this.package.installedTabletWidgetIds : JSON.parse(JSON.stringify(this.package.installedWidgetIds));
    this.package.installedTVAppIds = this.package.installedTVAppIds?.length ? this.package.installedTVAppIds : JSON.parse(JSON.stringify(this.package.installedAppIds));
    this.package.installedTVWidgetIds = this.package.installedTVWidgetIds?.length ? this.package.installedTVWidgetIds : JSON.parse(JSON.stringify(this.package.installedWidgetIds));
    const initialPak = JSON.stringify(this.package);
    const apps = (await this.appService.find(0, this.package.installedAppIds.length, { _id: { $in: this.package.installedAppIds } }))?.data;
    const widgetIds = apps.map(app => app.packageInstalledWidgetId);
    apps.map(app => app._id).forEach(id => {
      this.package.installedMobileAppIds.includes(id) || this.package.installedMobileAppIds.push(id);
      this.package.installedTabletAppIds.includes(id) || this.package.installedTabletAppIds.push(id);
      this.package.installedTVAppIds.includes(id) || this.package.installedTVAppIds.push(id);
    });
    widgetIds.forEach(id => {
      this.package.installedWidgetIds.includes(id) || this.package.installedWidgetIds.push(id);
      this.package.installedMobileWidgetIds.includes(id) || this.package.installedMobileWidgetIds.push(id);
      this.package.installedTabletWidgetIds.includes(id) || this.package.installedTabletWidgetIds.push(id);
      this.package.installedTVWidgetIds.includes(id) || this.package.installedTVWidgetIds.push(id);
    });
    if (JSON.stringify(this.package) != initialPak) {
      this.packageService.update(this.package._id, this.package);
    }
    this.compositions = (await this.compositionService.find(0, 100, { _id: { $in: this.package.compositionIds } })).data;
    this.compositions.forEach(c => this.languages = c.screen.availableLanguages);
    [['ibexTouch', 'ibextouch', 'installedAppIds'], ['ibexTablet', 'ibextablet', 'installedTabletAppIds'], ['ibexApp', 'ibexsmart', 'installedMobileAppIds'], ['ibexTV', 'ibexTV', 'installedTVAppIds']].forEach(el => {
      this.addButton(el[0], el[1], el[2]);
    });
    if (this.buttons.length === 0) {
      this.buttons.push({ title: 'ibextouch Applikationen', field: 'installedAppIds' });
    }
    if (this.app) {
      const index = this.buttons.findIndex(el => el.field === this.app);
      this.openNavigation((index !== -1) ? index : 0);
    } else {
      this.openNavigation();
    }
  }

  private addButton(type: string, title: string, appField: string) {
    if (this.package?.[type]?.enabled) {
      this.buttons.push({ title: title + ' Applikationen', field: appField });
      this.buttons.push({ title: title + ' Widgets', field: appField.replace('App', 'Widget') });
    }
  }

  async openNavigation(index = 0) {
    ['items', 'widgets', 'apps'].forEach(t => {
      this[t] = [];
    })
    this.selectedIndex = index;
    this.activeField = this.buttons?.[index]?.field;
    const ids = this.package[this.activeField];
    this.apps = [];
    this.widgets = [];
    if (ids?.length) {
      if (this.activeField?.includes('Widget')) {
        this.apps = (await this.appService.find(0, ids?.length || 1, { packageInstalledWidgetId: { $in: ids } })).data;
        this.widgets = (await this.widgetService.find(0, ids?.length || 1, { _id: { $in: ids } })).data;
        this.package[this.activeField] = this.package[this.activeField].filter(el => !!this.widgets.find(widget => widget._id === el));
      } else {
        this.apps = (await this.appService.find(0, ids?.length || 1, { _id: { $in: ids } })).data;
        this.package[this.activeField] = this.package[this.activeField].filter(el => !!this.apps.find(app => app._id === el));
      }
    }
    for (let i = 0; i < this.widgets.length; i++) {
      const app = this.apps.find(el => el.packageInstalledWidgetId === this.widgets[i]._id);
      if (app?.packageId !== this.packageId && app?.disabled) {
        ['installedWidgetIds', 'installedMobileWidgetIds', 'installedTabletWidgetIds', 'installedTVWidgetIds'].forEach(key => {
          this.package[key].push(this.package[key].splice(this.package[key].findIndex(id => id === this.widgets[i]._id), 1)[0]);
        });
        this.widgets.splice(i, 1);
      }
    }
    for (let i = 0; i < this.apps.length; i++) {
      if (this.apps[i].packageId !== this.packageId && this.apps[i].disabled) {
        ['installedAppIds', 'installedMobileAppIds', 'installedTabletAppIds', 'installedTVAppIds'].forEach(key => {
          this.package[key].push(this.package[key].splice(this.package[key].findIndex(id => id === this.apps[i]._id), 1)[0]);
        });
        this.apps.splice(i, 1);
      }
    }
    const compositionApps = (await this.compositionAppService.find(0, 100, { compositionId: { $in: this.package.compositionIds } })).data;
    const dcEntranceIds = [].concat(...this.compositions.map(el => el.dynamicContentIds));
    const dcEntrances = (await this.entranceService.find(0, dcEntranceIds.length, { _id: { $in: dcEntranceIds } })).data;
    const snippetIds = [].concat(...this.compositions.map(el => el.snippetIds));
    const snippets = (await this.snippetService.find(0, snippetIds.length, { _id: { $in: snippetIds } })).data;
    this.availableApps = dcEntrances.filter(el => !this.apps.find(app => app.dynamicContentEntranceId === el._id));
    this.availableApps = this.availableApps.concat(snippets.filter(el => !this.apps.find(app => app.codeSnippetId === el._id)) as any);
    this.availableApps = this.availableApps.concat(compositionApps.filter(el => !this.apps.find(app => app.compositionAppId === el._id)) as any);
    const elements = this.widgets.length ? this.widgets : this.apps;
    const entranceIds = this.apps.map(el => el.dynamicContentEntranceId).filter(el => !!el);
    const entrances = (await this.entranceService.find(0, entranceIds?.length, { _id: { $in: entranceIds } })).data;
    entrances.forEach(entrance => {
      this.entrancesById[entrance._id] = entrance;
    });
    const menuItems = await this.fetchInChunks(this.menuItemService, { _id: { $in: (compositionApps.map(el => el.translations.map(t => t.menuItemIds)) as any).flat().flat() } });
    const entries = await this.fetchInChunks(this.entryService, { _id: { $in: menuItems.map(el => el.entry) } });
    for (const entry of entries) {
      const compositionApp = compositionApps.find(c => c.translations.find(t => t.menuItemIds.includes(menuItems.find(el => el.entry === entry?._id)?._id)));
      if (compositionApp) {
        this.entryByCompositionAppId[compositionApp._id] = entry;
      }
    }
    this.items = elements.sort((a, b) => ids.indexOf(a._id) - ids.indexOf(b._id));
  }

  async fetchInChunks(service: any, query: any, chunkSize: number = 50): Promise<any[]> {
    const ids = query._id?.$in || [];
    if (!ids.length) {
      return [];
    }

    const results: any[] = [];

    for (let i = 0; i < ids.length; i += chunkSize) {
      const chunk = ids.slice(i, i + chunkSize);
      const chunkQuery = { ...query, _id: { $in: chunk } };
      const response = await service.find(0, 1000, chunkQuery);
      if (response?.data?.length) {
        results.push(...response.data);
      }
    }

    return results;
  }

  async drop(event) {
    moveItemInArray(this.package[this.activeField], event.previousIndex, event.currentIndex);
    const data = {};
    data[this.activeField] = this.package[this.activeField];
    await this.packageService.patch(this.packageId, data);
    moveItemInArray(this.items, event.previousIndex, event.currentIndex);
  }

  async edit(event: any, item) {
    event?.stopPropagation?.();
    event?.preventDefault?.();

    if (this.getApp(item).packageId !== this.packageId) {
      return;
    }

    const previousItem = JSON.parse(JSON.stringify(item));
    const entranceId = item.dynamicContentEntranceId || this.apps.find(el => el.packageInstalledWidgetId === item._id)?.dynamicContentEntranceId;

    const dialogRef = this.dialog.open(EditAppDialogComponent, {
      width: '1000px', maxHeight: '90vh', data: {
        item: JSON.parse(JSON.stringify(item)), type: this.activeField, entrance: this.entrancesById[entranceId],
        packageId: this.packageId, app: this.getApp(item),
        entry: this.entryByCompositionAppId[this.getApp(item)?.compositionAppId],
        availableLanguages: this.package.availableLanguagesCached, packageLang: this.package.masterLanguageCached
      }
    });
    const res = await dialogRef.afterClosed().toPromise();
    if (!res) {
      item = this.activeField?.includes('Widget') ? new Models.PackageInstalledWidget() : new Models.PackageInstalledApp();
      item.populateFromJSON(previousItem);
      return;
    }
    if (this.activeField === 'installedWidgetIds') {
      const translations = res?.translations ?? [];
      const german = translations.find(t => t.language === 'de');
      if (german) {
        for (const t of translations) {
          if (t === german) {
            continue;
          }
          for (const k of Object.keys(german)) {
            if (!(k in t) && k !== 'title' && k !== 'subtitle') {
              t[k] = german[k];
            }
          }
        }
      }
    }
    await (this.activeField?.includes('Widget') ? this.widgetService.update(res._id, res) : this.appService.update(res._id, res));
    this.items[this.items.findIndex(el => el._id === res._id)] = res;
    this.snackbar.success(this.ts.get('system.general.savedChanges'));
  }

  async remove(event: any, item) {
    event?.stopPropagation?.();
    event?.preventDefault?.();

    let confirmMessage = this.ts.get('packages.navigation.removeConfirmation');
    const dialogRes = await this.dialogService.confirm(confirmMessage, null);
    if (!dialogRes) {
      return;
    }

    const appId = item.packageInstalledWidgetId ? item._id : this.apps.find(el => el.packageInstalledWidgetId === item._id)?._id;
    const widgetId = item.packageInstalledWidgetId || item._id;
    ['installedAppIds', 'installedMobileAppIds', 'installedTabletAppIds', 'installedTVAppIds'].forEach(arr => this.package[arr] = this.package[arr].filter(el => el !== appId));
    ['installedWidgetIds', 'installedMobileWidgetIds', 'installedTabletWidgetIds', 'installedTVWidgetIds'].forEach(arr => this.package[arr] = this.package[arr].filter(el => el !== widgetId));
    try {
      await this.widgetService.remove(widgetId);
    } catch (err) {
      console.warn('could not delete widget, probably already deleted', err);
    }

    await this.appService.remove(appId);
    await this.packageService.patch(this.package._id, { ...this.package });

    let childPackages = [];
    let childIds = this.package.assignedChildPackages;

    while (childIds?.length) {
      const children = (await this.packageService.find(0, 1000, { _id: { $in: childIds } })).data;
      childPackages = childPackages.concat(children);
      childIds = (children.map(child => child.assignedChildPackages) as any).flat();
    }

    for (const pak of childPackages) {
      ['installedAppIds', 'installedMobileAppIds', 'installedTabletAppIds', 'installedTVAppIds'].forEach(arr => pak[arr] = pak[arr].filter(el => el !== appId));
      ['installedWidgetIds', 'installedMobileWidgetIds', 'installedTabletWidgetIds', 'installedTVWidgetIds'].forEach(arr => pak[arr] = pak[arr].filter(el => el !== widgetId));
      await this.packageService.patch(pak._id, { ...pak.package });
    }
    this.ngOnInit();
  }

  async resetHighscore(event: any, item) {
    event?.stopPropagation?.();
    event?.preventDefault?.();
    let confirmMessage = this.ts.get('packages.navigation.resetConfirmation');
    const dialogRes = await this.dialogService.confirm(confirmMessage, null);
    if (!dialogRes) {
      return;
    }
    await this.gameSession.remove(this.packageId);
    this.snackbar.success(this.ts.get('packages.navigation.resetConfirmed'));
  }

  public async toggleMasterPackageApp(appId) {
    this.package.disabledInheritedAppIds ??= [];
    if (this.package.disabledInheritedAppIds.includes(appId)) {
      this.package.disabledInheritedAppIds.splice(this.package.disabledInheritedAppIds.indexOf(appId), 1);
    } else {
      this.package.disabledInheritedAppIds.push(appId);
    }
    await this.packageService.patch(this.package._id, { disabledInheritedAppIds: this.package.disabledInheritedAppIds });
  }

  public async togglePackageApp(app) {
    app.disabled = !app.disabled;
    await this.appService.patch(app._id, { disabled: app.disabled });
  }

  isDisabledInherited(item) {
    return !this.package.disabledInheritedAppIds || this.package.disabledInheritedAppIds.includes(this.getApp(item)?._id);
  }

  getTitle(item) {
    const translation = item.translations.find(el => el.language === 'de') || item.translations[0];
    if (this.activeField?.includes('Widget')) {
      return translation?.title || this.apps.find(el => el.packageInstalledWidgetId === item._id)?.translations?.find(el => el.language === 'de')?.appTitle;
    }
    return translation?.appTitle;
  }

  getContentType(item) {
    if (this.activeField?.includes('Widget')) {
      item = this.apps.find(el => el.packageInstalledWidgetId === item._id);
    }
    const entrance = this.entrancesById[item?.dynamicContentEntranceId];
    return entrance?.config?.overwriteContentType || entrance?.type;
  }

  getType(item) {
    if (this.activeField?.includes('Widget')) {
      item = this.apps.find(el => el.packageInstalledWidgetId === item._id);
    }
    return item?.dynamicContentEntranceId ? `Eigener Inhalt - ${this.getContentType(item)}` : item?.compositionAppId ? 'Importierter Inhalt' : 'Spezialapp';
  }

  getTimes(item) {
    return (item?.tvWidgetConfig?.runtimes || [])
      .map(({ startTime, endTime }: any) => startTime && endTime ? `${startTime} - ${endTime}` : startTime ? `ab ${startTime}` : endTime ? `bis ${endTime}` : '').filter(Boolean)
      .map(line => `<div>${line}</div>`).join('');
  }

  getIcon(item) {
    return this.getApp(item)?.iconOverride;
  }

  isSecured(item) {
    return this.getApp(item)?.isSecured;
  }

  getApp(item) {
    return this.apps.find(el => el.packageInstalledWidgetId === item._id) || item;
  }

  async openAppCreator() {
    const dialogRef = this.dialog.open(ApplicationGenerationComponent, { width: '75vw' });
    const result = await dialogRef.afterClosed().toPromise();
    if (!result) {
      return;
    }
    await this.createApp(result, this.package.compositionIds[this.package.compositionIds.length - 1]);
  }

  async createApp(app, compositionId) {
    let entranceId, compositionAppId, codeSnippetId;
    const comp = await this.compositionService.get(compositionId);

    if (app.type === 'dynamicContent') {
      const entrance = {
        title: app.title, type: app.subType === 'memory' ? 'gallery' : app.subType, OwnerOrganisationID: this.package.OwnerOrganisationID, OwnerCustomerID: this.package.customerId,
        config: app.subType === 'memory' ? { overwriteContentType: 'memory' } : app.subType === 'new' ? { overwriteContentType: 'news', renderAsRelated: true, startLevel: 1 } : {}
      };
      entranceId = (await this.entranceService.create(entrance))._id;
    } else if (app.type === 'import') {
      const importIds = app.languageSpecific ? Object.keys(app.importsByLanguage)
        .reduce((ids, key) => ids.concat(app.importsByLanguage[key].map(el => el.id)), []) : app.imports.map(el => el.id);

      const imports = (await this.importService.find(0, importIds.length, { _id: { $in: importIds } })).data;
      comp.importIds = (comp.importIds || []).concat(importIds);
      await this.compositionService.patch(compositionId, { importIds: comp.importIds });

      const translations = app.languageSpecific ? Object.keys(app.importsByLanguage).map(language => ({
        language, appTitle: app.title, menuItemIds: app.importsByLanguage[language]
          .map(importElement => imports.find(contentImport => contentImport._id.toString() === importElement.id.toString())?.assignableMenuItems?.[0]?.menuItemId)
          .filter(Boolean)
      })) : this.package.availableLanguagesCached.map(language => ({
        language, appTitle: app.title, menuItemIds: app.imports.map(importElement =>
          imports.find(contentImport => contentImport._id.toString() === importElement.id.toString())?.assignableMenuItems?.[0]?.menuItemId
        ).filter(Boolean)
      }));

      compositionAppId = (await this.compositionAppService.create({ compositionId, name: app.title, translations }))._id;
    } else {
      codeSnippetId = app.subType;
    }

    let languages = this.package.availableLanguagesCached;
    if (!languages?.length && !!comp?.screen?.availableLanguages) {
      languages = comp?.screen?.availableLanguages;
    }
    this.package.availableLanguagesCached = languages;
    const appRes = await this.createAppAndWidget({ app, entranceId, compositionAppId, codeSnippetId, languages, compositionId });

    ['installedAppIds', 'installedMobileAppIds', 'installedTabletAppIds', 'installedTVAppIds'].forEach(arr => this.package[arr].push(appRes.appId));
    ['installedWidgetIds', 'installedMobileWidgetIds', 'installedTabletWidgetIds', 'installedTVWidgetIds'].forEach(arr => this.package[arr].push(appRes.widgetId));
    await this.packageService.patch(this.package._id, this.package);
    await this.openNavigation(this.selectedIndex);
  }

  private async createAppAndWidget({ app, languages, entranceId, compositionAppId, codeSnippetId, compositionId }) {
    const appTranslations = languages.map(language => ({ appTitle: app.title, language }));
    const widgetTranslations = languages.map(language => ({ language }));

    const widgetResult = await this.widgetService.create({
      packageId: this.package._id, disabled: false, screenDisabled: false, mobileDisabled: false, default: true, translations: widgetTranslations
    });

    const appResult = await this.appService.create({
      packageId: this.package._id, translations: appTranslations, packageInstalledWidgetId: widgetResult._id, compositionId, iconOverride: '', disabled: false, isSecured: false,
      screenDisabled: false, mobileDisabled: false, skipWhenOnlyChild: app.type === 'import', dynamicContentEntranceId: entranceId, compositionAppId, codeSnippetId
    });

    return { widgetId: widgetResult._id, appId: appResult._id };
  }

  async resetAppOrders() {
    const titles = {
      installedAppIds: 'ibextouch Applikationen', installedWidgetIds: 'ibextouch Widgets', installedTabletAppIds: 'ibextablet Applikationen',
      installedTVAppIds: 'ibexTV Applikationen',installedTVWidgetIds: 'ibexTV Widgets', installedTabletWidgetIds: 'ibextablet Widgets',
      installedMobileAppIds: 'ibexsmart Applikationen', installedMobileWidgetIds: 'ibexsmart Widgets'
    };

    if (!await this.dialogService.confirm(`Reihenfolge übertragen? Die Reihenfolge von ${titles[this.activeField]} wird auf alle anderen Reihenfolgen übertragen.`)) {
      return;
    }

    const [orderType, widgetOrder, appOrder] = this.activeField?.includes('Widget') ? ['packageInstalledWidgetId', this.package[this.activeField], this.getSortedApps('packageInstalledWidgetId')] : ['_id', this.getSortedApps('_id'), this.package[this.activeField]];

    const data = {
      installedAppIds: appOrder, installedWidgetIds: widgetOrder, installedMobileAppIds: appOrder, installedMobileWidgetIds: widgetOrder,
      ...(this.package?.ibexTablet?.enabled && { installedTabletAppIds: appOrder, installedTabletWidgetIds: widgetOrder }),
      ...(this.package?.ibexTV?.enabled && { installedTVAppIds: appOrder, installedTVWidgetIds: widgetOrder })
    };

    await this.packageService.patch(this.package._id, data);
    this.app = this.activeField;
    this.ngOnInit();
  }

  getSortedApps(orderKey) {
    const orderMap = this.package[this.activeField].reduce((acc, id, index) => ({ ...acc, [id]: index }), {});
    return this.apps.sort((a, b) => (orderMap[a[orderKey]] ?? Infinity) - (orderMap[b[orderKey]] ?? Infinity))
      .map(el => el[orderKey === '_id' ? 'packageInstalledWidgetId' : '_id']);
  }

  public async openAppPicker() {
    let dialogRef: MatDialogRef<AppPickerDialogComponent>;
    const config = new MatDialogConfig();
    dialogRef = this.dialog.open(AppPickerDialogComponent, config);
    dialogRef.componentInstance.availableApps = this.availableApps;
    const pickedApps = await dialogRef.afterClosed().toPromise();
    if (!pickedApps || pickedApps.length === 0) {
      return false;
    }
    await this.installNewApps(pickedApps);
  }

  private async installNewApps(pickedApps, disabled = false): Promise<any> {
    for (const app of pickedApps) {
      const newInstalledApp = new Models.PackageInstalledApp();
      const newInstalledWidget = new Models.PackageInstalledWidget();
      newInstalledApp.populateFromJSON({ iconOverride: undefined, packageId: this.package._id, translations: [], disabled });
      newInstalledWidget.populateFromJSON({ packageId: this.package._id, translations: [], disabled });
      if (app instanceof Models.CompositionApp) {
        Object.assign(newInstalledApp, {
          compositionAppId: app._id, compositionId: app.compositionId, translations: this.createTranslations(app, 'compositionApp'), skipWhenOnlyChild: true
        });
      } else if (app instanceof Models.DynamicContentEntrance) {
        const comp = this.compositions.find(c => c.dynamicContentIds.includes(app._id));
        Object.assign(newInstalledApp, {
          dynamicContentEntranceId: app._id, compositionId: comp._id, translations: this.createTranslations(app, 'dynamicContent'), iconOverride: this.getDynamicContentIcon(app)
        });
      } else if (app instanceof Models.CodeSnippet) {
        const comp = this.compositions.find(c => c.snippetIds.includes(app._id));
        Object.assign(newInstalledApp, { codeSnippetId: app._id, compositionId: comp._id, translations: this.createTranslations(app, 'codeSnippet'), });
      }

      if (this.package.isScreenPackage) {
        newInstalledWidget.translations = this.createWidgetTranslations();
        const widgetRes = await this.widgetService.create(newInstalledWidget);
        if (widgetRes._id) {
          newInstalledApp.packageInstalledWidgetId = widgetRes._id;
        }
      }
      const installedApp = await this.appService.create(newInstalledApp);
      this.package.installedAppIds = this.package.installedAppIds || [];
      this.package.installedMobileAppIds = this.package.installedMobileAppIds || [];
      this.package.installedAppIds.push(installedApp._id);
      this.package.installedMobileAppIds.push(installedApp._id);
      if (this.package.ibexTablet?.enabled) {
        this.package.installedTabletAppIds.push(installedApp._id);
      }
      if (this.package.ibexTV?.enabled) {
        this.package.installedTVAppIds.push(installedApp._id);
      }

      if (this.package.isScreenPackage) {
        this.package.installedWidgetIds = this.package.installedWidgetIds || [];
        this.package.installedMobileWidgetIds = this.package.installedMobileWidgetIds || [];
        this.package.installedWidgetIds.push(installedApp.packageInstalledWidgetId);
        this.package.installedMobileWidgetIds.push(installedApp.packageInstalledWidgetId);
        if (this.package.ibexTablet?.enabled) {
          this.package.installedTabletWidgetIds = this.package.installedTabletWidgetIds || [];
          this.package.installedTabletWidgetIds.push(installedApp.packageInstalledWidgetId);
        }
        if (this.package.ibexTV?.enabled) {
          this.package.installedTVWidgetIds = this.package.installedTVWidgetIds || [];
          this.package.installedTVWidgetIds.push(installedApp.packageInstalledWidgetId);
        }
      }

      await this.packageService.patch(this.package._id, {
        installedAppIds: this.package.installedAppIds, installedMobileAppIds: this.package.installedMobileAppIds,
        installedWidgetIds: this.package.installedWidgetIds, installedMobileWidgetIds: this.package.installedMobileWidgetIds,
      });

      let childPackages = [];
      let childIds = this.package.assignedChildPackages;
      while (childIds?.length) {
        const children = (await this.packageService.find(0, 1000, { _id: { $in: childIds } })).data;
        childPackages = childPackages.concat(children);
        childIds = children.map(child => child.assignedChildPackages).reduce((acc, val) => acc.concat(val), []);
      }
      for (const pak of childPackages) {
        if (!pak.installedAppIds.includes(installedApp._id)) { pak.installedAppIds.push(installedApp._id); }
        if (!pak.installedMobileAppIds.includes(installedApp._id)) { pak.installedMobileAppIds.push(installedApp._id); }
        if (!pak.installedWidgetIds.includes(installedApp._id)) { pak.installedWidgetIds.push(installedApp._id); }
        if (!pak.installedMobileWidgetIds.includes(installedApp._id)) { pak.installedMobileWidgetIds.push(installedApp._id); }
        await this.packageService.patch(pak._id, {
          installedAppIds: pak.installedAppIds, installedMobileAppIds: pak.installedMobileAppIds,
          installedWidgetIds: pak.installedWidgetIds, installedMobileWidgetIds: pak.installedMobileWidgetIds
        });
      }
    }

    await this.openNavigation(this.selectedIndex);
  }

  private createTranslations(pickedApp, type) {
    return this.languages.map(language => {
      const appTitle = type === 'dynamicContent' ? (this.getInstalledAppTranslation(pickedApp.title.toLowerCase())?.[language] || pickedApp.title) : pickedApp[type === 'compositionApp' ? 'name' : 'title'];
      const translation = new Models.PackageInstalledAppTranslation();
      translation.populateFromJSON({ language, hidden: false, appTitle });
      return translation;
    });
  }

  getInstalledAppTranslation(val) {
    return AppTranslationMap.get(val) ? AppTranslationMap.get(val) : AppTranslationMap.get(val.slice(0, -1));
  }

  async setFixed(event?: any) {
    this.package.screen.fixedWidgetId = event?.value;
    try {
      await this.packageService.patch(this.packageId, { 'screen.fixedWidgetId': this.package.screen.fixedWidgetId });
    } catch (error) {
      this.snackbar.error('Could not save fixed widget ' + error?.toString(), 5000);
    }
  }

  private createWidgetTranslations() {
    return this.languages.map(language => {
      const translation = new Models.PackageInstalledWidgetTranslation();
      translation.populateFromJSON({ language, hidden: false, title: null });
      return translation;
    });
  }

  private getDynamicContentIcon(app): string {
    return (AppTranslationMap.get(app.type) || AppTranslationMap.get(app.title?.toLowerCase()) || null)?.icon;
  }
}
